<template>
  <v-data-table
    :headers="headers"
    :items="referencias"
    class="transparent"
    :options="{ page: false }"
    :hide-default-footer="true"
  >
    <template v-slot:[`item.direccion`]="{ item }">
      <section>
        {{
          `${item.calle} ${item.interior ?? 'S/N'} entre calles ${item.entrecalles} y ${item.entrecalles2}, ${
            item.colonia
          }, ${item.localidad},`
        }}
      </section>
      <section v-if="item.municipio && item.estado">
        {{ `${item.municipio}, ${item.estado} CP #${item.cp}` }}
      </section>
      <section v-if="item.referencias">Referencia: {{ item.referencias }}</section>
    </template>
    <template v-slot:[`item.opciones`]="{ item }">
      <span class="d-flex align-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <IconButton class="mr-2" icon="mdi-pencil" variant="primary" @click="$emit('edit', item)" />
            </span>
          </template>
          <span>Editar Referencia</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <IconButton icon="mdi-delete" variant="error" @click="$emit('delete', item)" />
            </span>
          </template>
          <span>Eliminar Referencia</span>
        </v-tooltip>
      </span>
    </template>
  </v-data-table>
</template>

<script>
import IconButton from '../base/IconButton.vue'

export default {
  components: { IconButton },

  props: {
    referencias: {
      type: Array,
      required: true,
    },

    type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      personalHeaders: [
        { text: 'Nombre', value: 'nombre', width: '180px' },
        { text: 'Teléfono', value: 'telefono', width: '140px' },
        {
          text: 'Años de conocerlo',
          value: 'tiempoConocerse',
          align: 'right',
          width: '180px',
        },
        { text: '¿Cómo lo conoció?', value: 'comoConocio', align: 'right', width: '280px' },
        { text: 'Opciones', value: 'opciones' },
      ],

      laboralHeaders: [
        { text: 'Nombre', value: 'nombre', width: '150px' },
        { text: 'Teléfono', value: 'telefono', width: '100px' },
        { text: 'Tipo', value: 'tipo', width: '100px' },
        { text: 'Cargo', value: 'cargo', width: '100px' },
        { text: 'Corporación, Institución o Empresa', value: 'corporacion', width: '250px' },
        { text: 'Tiempo laborado (años)', value: 'tiempoLaborado', width: '150px', align: 'right' },
        { text: 'Opciones', value: 'opciones' },
      ],

      vecinalHeaders: [
        { text: 'Nombre', value: 'nombre', width: '100px' },
        { text: 'Teléfono', value: 'telefono', width: '100px' },
        { text: 'Tiempo de ser vecinos (años)', value: 'tiempoConocerse', width: '120px', align: 'right' },
        { text: 'Dirección', value: 'direccion', width: '480px' },
        { text: 'Opciones', value: 'opciones' },
      ],
    }
  },

  computed: {
    headers() {
      if (this.type === 'laboral') return this.laboralHeaders
      if (this.type === 'vecinal') return this.vecinalHeaders

      return this.personalHeaders
    },
  },
}
</script>
